/**
 * Validates and formats a subscription end date string into "Month Day, Year" format.
 * @param dateString - The date string to validate and format (e.g., "2026-04-10T06:41:04+00:00").
 * @returns {string} - The formatted date string or "Invalid date" if the input is invalid.
 */
export const formatSubscriptionEndDate = (dateString: string): string => {
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return "Invalid date"; // Handle invalid date
        }
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    } catch (error) {
        return "Invalid date"; // Catch unexpected errors
    }
};